/* eslint-disable import/prefer-default-export */
import ActionTypes from '../constants/ActionTypes';

export const getWLCompanyData = () => ({
  type: ActionTypes.GET_WHITELABEL_COMPANY_DATA,
});
